import React from 'react';
import '../scss/button.scss';
import { ReactComponent as StarfinLogo } from '../images/stashfin-logo.svg'
import { ReactComponent as VerifyBankImg } from '../images/verify-bank.svg'
import { useNavigate } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
function VerifyBank() {
    const navigate = useNavigate()
    return (
        <div className='external-wrapper verify-bank'>
            <div className='page-content'>
                <PageHeader />
                <div className='page-heading'>
                    <h2 className='page-title'>Verify Your Bank Account</h2>
                </div>
                <div className='verify-content'>
                    <VerifyBankImg className='bank-image' />
                    <h3>100% Safe & secured</h3>
                    <p>Securely fetch your bank statements for quick verification through an RBI approved account aggregator service.</p>
                </div>
            </div>
            <div className='bottom-footer'>
                <p className='powered-by'>Powered by <StarfinLogo /></p>
                <button type="submit" className="btn btn-primary" onClick={() => {
                    localStorage.setItem("lastVisitedPage", '/retrive-bank')
                    navigate('/retrive-bank')
                }}>Next</button>
            </div>
        </div>
    );
}

export default VerifyBank;
